import { z } from "zod";

export const objectiveMetadataSchema = z.object({
  protocolName: z.string().nullish(),
  protocolId: z.number().nullish(),
  value: z.number(),
  metric: z.enum(["address_count"]),
  scoreMin: z.number().nullish(),
  scoreMax: z.number().nullish(),
});

export type ObjectiveMetadata = z.infer<typeof objectiveMetadataSchema>;

export type Quest = {
  id: string;
  status: string;
};

export type Journey = {
  id: string;
  status: string;
};

export type Objective = {
  id: string;
  name: string;
  slug: string;
  metadata: ObjectiveMetadata | null;
  playbookId: string;
  budgetUsd: number;
  createdById: string;
  updatedById: string;
  createdAt: Date;
  updatedAt: Date;
  promptId: string | null;
  quests?: Quest[];
  journeys?: Journey[];
};

export type ObjectiveCreate = Pick<Objective, "name" | "metadata" | "playbookId" | "promptId" | "budgetUsd">;

export type ObjectiveUpdate = Partial<Pick<Objective, "name" | "metadata">> & {
  budgetUsd?: number;
};

export const objectiveSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  metadata: objectiveMetadataSchema.nullable(),
  playbookId: z.string(),
  budgetUsd: z.number(),
  createdById: z.string(),
  updatedById: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  promptId: z.string(),
  quests: z
    .array(
      z.object({
        id: z.string(),
        status: z.string(),
      }),
    )
    .optional(),
  journeys: z
    .array(
      z.object({
        id: z.string(),
        status: z.string(),
      }),
    )
    .optional(),
}) satisfies z.ZodType<Objective>;

export const objectiveCreateSchema = z.object({
  name: z.string(),
  metadata: objectiveMetadataSchema.nullable(),
  playbookId: z.string(),
  promptId: z.string(),
  budgetUsd: z.number(),
}) satisfies z.ZodType<ObjectiveCreate>;

export const objectiveUpdateSchema = z.object({
  name: z.string().optional(),
  metadata: objectiveMetadataSchema.nullable().optional(),
  budgetUsd: z.number().optional(),
}) satisfies z.ZodType<ObjectiveUpdate>;
